import React from "react";

type DialogFooterProps = {
  children: React.ReactNode;
};

export const DialogFooter = ({ children }: DialogFooterProps) => {
  return <div className={"flex flex-row-reverse gap-3 pt-6"}>{children}</div>;
};
